module.exports = __webpack_public_path__ + "img/logo-4.fd496259.png";